<div
  class="gallery-section"
  (dragover)="$event.stopPropagation()"
  (dragenter)="$event.stopPropagation()"
>
  <div class="section-header">
    <h5 class="section-title">معرض صور الخدمة</h5>
    <p class="section-description">
      يمكنك إضافة صور متعددة للخدمة وإعادة ترتيبها (اختياري)
    </p>
  </div>

  <div class="gallery-upload-area">
    <button
      type="button"
      class="btn-upload-gallery"
      (click)="triggerGalleryUpload()"
    >
      <img src="assets/images/svg/upload-icon.svg" alt="upload" />
      <span>إضافة صور للمعرض</span>
    </button>
    <input
      type="file"
      id="galleryFileInput"
      accept="image/jpeg,image/png,image/webp"
      multiple
      style="display: none"
      (change)="onGalleryImageSelected($event)"
    />
  </div>

  @if (galleryImages.length > 0) {
    <div class="gallery-grid">
      @for (image of galleryImages; let i = $index; track image.id) {
        <div
          class="gallery-item"
          draggable="true"
          (dragstart)="onDragStart($event, i)"
          (dragover)="onDragOver($event)"
          (drop)="onDrop($event, i)"
          (dragend)="onDragEnd()"
          (dragleave)="onDragLeave($event)"
        >
          <div class="gallery-thumbnail" (click)="openGalleryModal(i)">
            <img [src]="image.thumbnail" [alt]="image.name" />
            <div class="image-overlay">
              <span class="view-icon">
                <svg
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                  fill="none"
                  stroke="currentColor"
                  stroke-width="2"
                >
                  <path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"></path>
                  <circle cx="12" cy="12" r="3"></circle>
                </svg>
              </span>
            </div>
          </div>
          <button
            type="button"
            class="btn-action btn-delete"
            (click)="deleteGalleryImage(i)"
            title="حذف"
          >
            <img
              alt=""
              src="assets/images/svg/DELETE1.svg"
              width="16"
              height="16"
            />
          </button>
          <div class="drag-handle" title="اسحب لإعادة الترتيب">⋮⋮</div>
        </div>
      }
    </div>

    <!-- Pagination Controls -->
    @if (totalGalleryCount > 0 && totalGalleryPages > 1) {
      <div class="gallery-pagination">
        <div class="pagination-info">
          <span>صفحة {{ currentGalleryPage }} من {{ totalGalleryPages }}</span>
          <span class="total-count">({{ totalGalleryCount }} صورة)</span>
        </div>

        <div class="pagination-controls">
          <button
            type="button"
            class="btn-page"
            [disabled]="currentGalleryPage === 1"
            (click)="previousGalleryPage()"
            title="الصفحة السابقة"
          >
            →
          </button>

          @for (page of getGalleryPageNumbers(); track page) {
            <button
              type="button"
              class="btn-page"
              [class.active]="page === currentGalleryPage"
              (click)="goToGalleryPage(page)"
            >
              {{ page }}
            </button>
          }

          <button
            type="button"
            class="btn-page"
            [disabled]="currentGalleryPage === totalGalleryPages"
            (click)="nextGalleryPage()"
            title="الصفحة التالية"
          >
            ←
          </button>
        </div>
      </div>
    }
  }

  @if (galleryImages.length === 0) {
    <div class="gallery-empty-state">
      <p>لم يتم إضافة صور للمعرض بعد</p>
    </div>
  }
</div>

<!-- Gallery Modal/Lightbox -->
@if (showGalleryModal && galleryImages.length > 0) {
  <div class="gallery-modal-overlay" (click)="closeGalleryModal()">
    <button type="button" class="modal-close" (click)="closeGalleryModal()">
      ✕
    </button>

    <div class="gallery-modal" (click)="$event.stopPropagation()">
      <!-- Left Arrow (Previous in RTL) -->
      <button
        type="button"
        class="modal-nav-arrow modal-arrow-left"
        [disabled]="selectedGalleryIndex === galleryImages.length - 1"
        (click)="nextImage()"
        title="التالي"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="15 18 9 12 15 6"></polyline>
        </svg>
      </button>

      <!-- Right Arrow (Next in RTL) -->
      <button
        type="button"
        class="modal-nav-arrow modal-arrow-right"
        [disabled]="selectedGalleryIndex === 0"
        (click)="previousImage()"
        title="السابق"
      >
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          stroke="currentColor"
          stroke-width="2"
        >
          <polyline points="9 18 15 12 9 6"></polyline>
        </svg>
      </button>

      <div class="md-content">
        <img
          [src]="galleryImages[selectedGalleryIndex].image"
          [alt]="galleryImages[selectedGalleryIndex].name"
          class="modal-image"
        />
      </div>

      <div class="modal-thumbnails">
        @for (image of galleryImages; let i = $index; track image.id) {
          <div
            class="modal-thumbnail"
            [class.active]="i === selectedGalleryIndex"
            (click)="selectedGalleryIndex = i"
          >
            <img [src]="image.thumbnail" [alt]="image.name" />
          </div>
        }
      </div>
    </div>
  </div>
}
